import type { FC } from "react";

import { Button } from "@jti/core-components/components/Button";
import { useTranslations } from "@jti/ui";

import styles from "./PricesFooter.module.scss";

type Props = {
  disabled?: boolean;
  onCheckout(): void;
};

const PricesFooter: FC<Props> = ({ disabled, onCheckout }) => {
  const { __ } = useTranslations();
  return (
    <div className={styles.container}>
      <Button
        className={styles.button}
        onClick={onCheckout}
        variant="primary"
        size="md"
        disabled={disabled}
        data-testid="loginCheckoutButton"
      >
        {__("cart.button.checkout")}
      </Button>
    </div>
  );
};

export default PricesFooter;
